import { render, staticRenderFns } from "./algemene-voorwaarden.vue?vue&type=template&id=2709733e&scoped=true"
import script from "./algemene-voorwaarden.vue?vue&type=script&lang=js"
export * from "./algemene-voorwaarden.vue?vue&type=script&lang=js"
import style0 from "./algemene-voorwaarden.vue?vue&type=style&index=0&id=2709733e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2709733e",
  null
  
)

export default component.exports